<template>
  <div>
    <CustomPageHeaderVue>{{ $t('faq-title') }}</CustomPageHeaderVue>
    <CustomRow>
      <div class="mt-5">
        <v-expansion-panels accordion v-model="expandItem">
          <v-expansion-panel class="mb-4 rounded-lg">
            <v-expansion-panel-header @click="toggleCollapse('成為 Ticket Plus遠大售票系統 會員')">
              <h2 :class="{
                'text-big-title': $vuetify.breakpoint.xs
              }">
                <v-icon color="black">{{
                  expandItem == "0" ? "mdi-minus" : "mdi-plus"
                }}</v-icon>
                {{ $t('faq-sec-1') }}
              </h2>
              <template v-slot:actions>
                <v-icon></v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider />
              <v-expansion-panels accordion v-model="expandItem1" multiple>
                <v-expansion-panel class="insideItems">
                  <v-expansion-panel-header @click="toggleCollapse('如何加入會員？')">
                    <h3 class="primary-1--text" :class="{ 'text-page-title': $vuetify.breakpoint.xs }">
                      <v-icon color="primary-1">{{
                        expandItem1.includes(0) ? "mdi-minus" : "mdi-plus"
                      }}</v-icon>
                      {{ $t('faq-sec-1-list-1') }}
                    </h3>
                    <template v-slot:actions>
                      <v-icon></v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="line-height:1.6" class="px-6">
                    <ul>
                      <li class="mb-4">{{ $t('faq-sec-1-list-1-item-1') }}
                      </li>
                      <li class="mb-4">{{ $t('faq-sec-1-list-1-item-2') }}
                      </li>
                      <li class="mb-4">{{ $t('faq-sec-1-list-1-item-3') }}
                      </li>
                      <li class="mb-4" v-html="$t('faq-sec-1-list-1-item-4', {
                        register_terms: termsLink,
                        register_and: andText,
                        register_privacy: privcyLink,
                      })">
                      </li>
                    </ul>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="insideItems">
                  <v-expansion-panel-header @click="toggleCollapse('忘記密碼')">
                    <h3 class="primary-1--text" :class="{ 'text-page-title': $vuetify.breakpoint.xs }">
                      <v-icon color="primary-1">{{
                        expandItem1.includes(1) ? "mdi-minus" : "mdi-plus"
                      }}</v-icon>
                      {{ $t('faq-sec-1-list-2') }}
                    </h3>
                    <template v-slot:actions>
                      <v-icon></v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="line-height:1.6" class="px-6">{{ $t('faq-sec-1-list-2-item-1') }}
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="insideItems">
                  <v-expansion-panel-header>
                    <h3 class="primary-1--text" :class="{ 'text-page-title': $vuetify.breakpoint.xs }">
                      <v-icon color="primary-1">{{
                        expandItem1.includes(2) ? "mdi-minus" : "mdi-plus"
                      }}</v-icon>{{ $t('faq-sec-1-list-3') }}
                    </h3>
                    <template v-slot:actions>
                      <v-icon></v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="line-height:1.6" class="px-6">{{ $t('faq-sec-1-list-3-item-1') }}
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="mb-4 rounded-lg">
            <v-expansion-panel-header @click="toggleCollapse('購票提醒')">
              <h2 :class="{
                'text-big-title': $vuetify.breakpoint.xs
              }">
                <v-icon color="black">{{
                  expandItem == "1" ? "mdi-minus" : "mdi-plus"
                }}</v-icon>
                {{ $t('faq-sec-2') }}
              </h2>
              <template v-slot:actions>
                <v-icon></v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider />
              <v-expansion-panels accordion v-model="expandItem2" multiple>
                <v-expansion-panel class="insideItems">
                  <v-expansion-panel-header @click="toggleCollapse('如何付款？')">
                    <h3 class="primary-1--text" :class="{ 'text-page-title': $vuetify.breakpoint.xs }">
                      <v-icon color="primary-1">{{
                        expandItem2.includes(0) ? "mdi-minus" : "mdi-plus"
                      }}</v-icon>
                      {{ $t('faq-sec-2-list-1') }}
                    </h3>
                    <template v-slot:actions>
                      <v-icon></v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="line-height:1.6" class="px-6">
                    <h4 class="mb-2">
                      <a href="https://static.ticketplus.com.tw/form/Ticket_plus%E8%B3%BC%E7%A5%A8%E6%B5%81%E7%A8%8B%E7%B6%B2%E7%AB%99%E9%80%9A%E7%94%A8%E7%89%88.pdf"
                        target="_blank">{{ $t('faq-sec-2-list-1-title-1') }}</a>
                    </h4>
                    <ul>
                      <li class="mb-4">
                        {{ $t('faq-sec-2-list-1-item-1') }}
                      </li>
                      <li>
                        {{ $t('faq-sec-2-list-1-item-2') }}
                      </li>
                    </ul>
                    <h4 class="mt-4 mb-2">
                      <a href="https://static.ticketplus.com.tw/form/ibon%E8%B3%BC%E7%A5%A8%E6%B5%81%E7%A8%8B.pdf"
                        target="_blank">{{ $t('faq-sec-2-list-1-title-2') }}</a>
                    </h4>
                    <ul>
                      <li class="mb-4">
                        {{ $t('faq-sec-2-list-1-item-3') }}
                      </li>
                    </ul>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="insideItems">
                  <v-expansion-panel-header @click="toggleCollapse('什麼是虛擬帳號付款？')">
                    <h3 class="primary-1--text" :class="{ 'text-page-title': $vuetify.breakpoint.xs }">
                      <v-icon color="primary-1">{{
                        expandItem2.includes(1) ? "mdi-minus" : "mdi-plus"
                      }}</v-icon>
                      {{ $t('faq-sec-2-list-2') }}
                    </h3>
                    <template v-slot:actions>
                      <v-icon></v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="line-height:1.6" class="px-6">
                    <ul>
                      <li class="mb-4">
                        {{ $t('faq-sec-2-list-2-item-1') }}
                      </li>
                      <li class="mb-4">
                        {{ $t('faq-sec-2-list-2-item-2') }}
                      </li>
                      <li class="mb-4">
                        {{ $t('faq-sec-2-list-2-item-3') }}
                      </li>
                      <li class="mb-4">
                        {{ $t('faq-sec-2-list-2-item-4') }}
                      </li>
                      <li class="mb-4">
                        {{ $t('faq-sec-2-list-2-item-5') }}
                      </li>
                    </ul>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- <v-expansion-panel class="insideItems">
                  <v-expansion-panel-header>
                    <div class="primary-1--text">
                      <v-icon color="primary-1">{{
                        expandItem2.includes(2) ? "mdi-minus" : "mdi-plus"
                      }}</v-icon>
                      可否在便利商店機台購票？
                    </div>
                    <template v-slot:actions>
                      <v-icon></v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content
                    style="line-height:1.6"
                    class="px-6"
                  >
                    <ul>
                      <li class="mb-4">
                        超商購票僅接受現金交易，目前提供「ibon
                        便利生活站」、「全家FamiPort」
                      </li>
                      <li class="mb-4">
                        每筆訂單不得超過4張票，如欲訂購4張以上之票券，請重覆進行交易
                      </li>
                      <li>
                        請拿取「繳費單」及「持票須知」二聯，
                        並於10分鐘內持繳費單至門市櫃檯取票，若無法即時完成結帳取票動作，恕無法保證座位
                      </li>
                    </ul>
                  </v-expansion-panel-content>
                </v-expansion-panel> -->
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="mb-4 rounded-lg">
            <v-expansion-panel-header @click="toggleCollapse('取票方式')">
              <h2 :class="{
                'text-big-title': $vuetify.breakpoint.xs
              }">
                <v-icon color="black">{{
                  expandItem == "2" ? "mdi-minus" : "mdi-plus"
                }}</v-icon>
                {{ $t('faq-sec-3') }}
              </h2>
              <template v-slot:actions>
                <v-icon></v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider />
              <v-expansion-panels accordion v-model="expandItem3" multiple>
                <v-expansion-panel class="insideItems">
                  <v-expansion-panel-header @click="toggleCollapse('超商取票')">
                    <h3 class="primary-1--text" :class="{ 'text-page-title': $vuetify.breakpoint.xs }">
                      <v-icon color="primary-1">{{
                        expandItem3.includes(0) ? "mdi-minus" : "mdi-plus"
                      }}</v-icon>
                      {{ $t('faq-sec-3-list-1') }}
                    </h3>
                    <template v-slot:actions>
                      <v-icon></v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="line-height:1.6" class="px-6">
                    <ul>
                      <li class="mb-4">
                        {{ $t('faq-sec-3-list-1-item-1') }}
                      </li>
                      <li class="mb-4">
                        {{ $t('faq-sec-3-list-1-item-2') }}
                      </li>
                      <li class="mb-4">
                        {{ $t('faq-sec-3-list-1-item-3') }}
                      </li>
                      <li class="mb-4">
                        {{ $t('faq-sec-3-list-1-item-4') }}
                      </li>
                      <li class="mb-4">
                        {{ $t('faq-sec-3-list-1-item-5') }}
                      </li>
                      <li class="mb-4">
                        <a href="https://static.ticketplus.com.tw/form/ibon%E5%8F%96%E7%A5%A8%E6%B5%81%E7%A8%8B.pdf"
                          target="_blank">{{ $t('faq-sec-3-list-1-item-6') }}</a>
                      </li>
                    </ul>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="insideItems">
                  <v-expansion-panel-header @click="toggleCollapse('郵局寄送 (限國內)')">
                    <h3 class="primary-1--text" :class="{ 'text-page-title': $vuetify.breakpoint.xs }">
                      <v-icon color="primary-1">{{
                        expandItem3.includes(1) ? "mdi-minus" : "mdi-plus"
                      }}</v-icon>
                      {{ $t('faq-sec-3-list-2') }}
                    </h3>
                    <template v-slot:actions>
                      <v-icon></v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="line-height:1.6" class="px-6">
                    <ul>
                      <li class="mb-4">
                        {{ $t('faq-sec-3-list-2-item-1') }}
                      </li>
                      <li class="mb-4">
                        {{ $t('faq-sec-3-list-2-item-2') }}
                      </li>
                      <li class="mb-4">
                        {{ $t('faq-sec-3-list-2-item-3') }}
                      </li>
                      <li class="mb-4">
                        {{ $t('faq-sec-3-list-2-item-4') }}
                      </li>
                    </ul>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="mb-4 rounded-lg">
            <v-expansion-panel-header @click="toggleCollapse('退換票規定')">
              <h2 :class="{
                'text-big-title': $vuetify.breakpoint.xs
              }">
                <v-icon color="black">{{
                  expandItem == "3" ? "mdi-minus" : "mdi-plus"
                }}</v-icon>
                {{ $t('faq-sec-4') }}
              </h2>
              <template v-slot:actions>
                <v-icon></v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider />
              <div class="my-8" :class="{ 'px-8': !$vuetify.breakpoint.xs }" style="line-height:1.6"
                v-html="$t('faq-sec-4-content')">
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="mb-4 rounded-lg">
            <v-expansion-panel-header @click="toggleCollapse('其他')">
              <h2 :class="{
                'text-big-title': $vuetify.breakpoint.xs
              }">
                <v-icon color="black">{{
                  expandItem == "4" ? "mdi-minus" : "mdi-plus"
                }}</v-icon>
                {{ $t('faq-sec-5') }}
              </h2>
              <template v-slot:actions>
                <v-icon></v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider />
              <v-expansion-panels accordion v-model="expandItem4" multiple>
                <v-expansion-panel class="insideItems">
                  <v-expansion-panel-header>
                    <h3 class="primary-1--text" :class="{ 'text-page-title': $vuetify.breakpoint.xs }">
                      <v-icon color="primary-1">{{
                        expandItem4.includes(0) ? "mdi-minus" : "mdi-plus"
                      }}</v-icon>
                      {{ $t('faq-sec-5-list-1') }}
                    </h3>
                    <template v-slot:actions>
                      <v-icon></v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="line-height:1.6" class="px-6">
                    {{ $t('faq-sec-5-list-1-content') }}
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="insideItems">
                  <v-expansion-panel-header>
                    <h3 class="primary-1--text" :class="{ 'text-page-title': $vuetify.breakpoint.xs }">
                      <v-icon color="primary-1">{{
                        expandItem4.includes(1) ? "mdi-minus" : "mdi-plus"
                      }}</v-icon>
                      {{ $t('faq-sec-5-list-2') }}
                    </h3>
                    <template v-slot:actions>
                      <v-icon></v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="line-height:1.6" class="px-6">
                    {{ $t('faq-sec-5-list-2-content') }}
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </CustomRow>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomPageHeaderVue from "@/components/CustomPageHeader.vue";

export default {
  components: { CustomPageHeaderVue },
  data() {
    return {
      expandItem: null,
      expandItem1: [],
      expandItem2: [],
      expandItem3: [],
      expandItem4: [],
      expandItem5: []
    };
  },
  metaInfo() {
    return {
      title: `${this.$t('faq-title')} - ${this.$t('app_name')}`,
      meta: [
        {
          property: 'og:title',
          content: `${this.$t('faq-title')} - ${this.$t('app_name')}`,
          vmid: 'og:title'
        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        }
      ],
      script: [{
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": `${this.$t('faq-title')} - ${this.$t('app_name')}`,
          "url": window.location.href
        }
      }]
    }
  },
  computed: {
    ...mapGetters({
      refundPdfUrl: "user/pdfUrl"
    }),
    termsLink() {
      return `<a class="primary-1--text cursor-pointer" href="/terms">${this.$t('register_terms')}</a>`
    },
    andText() {
      return this.$t('register_and')
    },
    privcyLink() {
      return `<a class="primary-1--text cursor-pointer" href="/terms#privacy">${this.$t('register_privacy')}</a>`
    },
  },
  methods: {
    toggleCollapse(faq) {
    }
  },
  mounted() {
    setTimeout(() => {
      this.$gtm.trackView(`常見問題`, this.$route.path);
      this.$store.dispatch("setOverlayLoading", false);
    }, 200);
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-expansion-panels>.v-expansion-panel {
    &::before {
      box-shadow: $shadow !important;
    }

    .v-expansion-panel-content .v-expansion-panel-content__wrap {
      padding-top: 12px;

      img {
        max-width: 100%;
        margin-bottom: 16px;
      }

      >.v-expansion-panels {
        margin-top: 10px;
      }

      >.v-expansion-panels>.v-expansion-panel::before {
        box-shadow: none !important;
      }
    }
  }
}

.insideItems.v-expansion-panel {
  padding: 0 40px;
  box-shadow: none;

  @media only screen and (max-width: 960px) {
    padding: 0;
  }

  &::before {
    box-shadow: none;
  }

  &::after {
    border-color: white !important;
  }
}

.red1--text {
  color: #ff0032;
}

.cusPadding {
  text-align: center;
  padding: 85px 100px;

  @media screen and (max-width: 600px) {
    padding: 50px;
  }

  @media only screen and (min-width: 600px) and (max-width: 960px) {
    padding: 50px;
  }
}

.divvider {
  height: 50%;
  width: 1px;
  background-color: #c4c4c4;
  margin: auto;
}
</style>
